import React from 'react';
import PropTypes from 'prop-types';

import { strings } from '../../../../localization';
import ProgressOverlay from '../../../../components/common/ProgressOverlay';
import { ModalContainer } from '../../../../components/common/Modal2';


import { UPDATE_SETTINGS_TIMEOUT } from '../GlobalSettings';


async function RRW_SIMULATE_DELAY_DEV_ONLY(delayTime = 3000) {
    await new Promise(resolve => setTimeout(resolve, delayTime));
}

const ACCOUNT_TOKEN_MIN_LENGTH = 10
const API_KEY_MIN_LENGTH = 40

export default class FleetioIntegration extends React.PureComponent {

    static propTypes = {
        integrationsFleetioCredentialsPending: PropTypes.bool.isRequired,
        timeoutIntegrationsFleetioCredentials: PropTypes.func.isRequired,
        integrationsFleetioCredentialsAccountToken: PropTypes.string,
        integrationsFleetioCredentialsApiKey: PropTypes.string,
        integrationsFleetioCredentialsIntegrationId: PropTypes.string,
        applyIntegrationsFleetioCredentials: PropTypes.func.isRequired,
        integrationsFleetioCredentialsStatus: PropTypes.string,
        integrationsFleetioCredentialsErrorMessage: PropTypes.string,
        integrationsFleetioCredentialsStatusMessage: PropTypes.string,
        integrationsFleetioCredentialsVerificationPending: PropTypes.bool,
        integrationsFleetioCredentialsVerificationIsValid: PropTypes.bool,
        integrationsFleetioCredentialsVerificationErrorMessage: PropTypes.string,
        showConfirmationDialog: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        integrationsExpandReference: PropTypes.string.isRequired,
        integrationsExpandReferenceIsExpanded: PropTypes.bool.isRequired,
        integrationsFleetioCredentialsExpandReference: PropTypes.string.isRequired,
        integrationsFleetioCredentialsExpandReferenceIsExpanded: PropTypes.bool.isRequired
    }

    constructor(props) {

        super(props);

        this.state = {
            fleetioIntegrationCredentialsVerificationPending: false,
            fleetioIntegrationCredentialsVerificationSucceeded: false,
            fleetioIntegrationCredentialsVerificationFailed: false,
            fleetioIntegrationCredentialsVerificationErrorMessage: null,
            moreInfoTooltipVisible: false
        };

        this.applyIntegrationsFleetioCredentialsTimeoutId = undefined;
    }

    fleetioIntegrationCheckCredentials = async () => {

        this.setState({fleetioIntegrationCredentialsVerificationPending: true});

        await RRW_SIMULATE_DELAY_DEV_ONLY(2000);

        this.setState({
            fleetioIntegrationCredentialsVerificationPending: false,
            fleetioIntegrationCredentialsVerificationSucceeded: true
        });
    }

    componentWillUnmount() {
        clearTimeout(this.applyIntegrationsFleetioCredentialsTimeoutId);
    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.integrationsExpandReference,
            this.props.integrationsFleetioCredentialsExpandReference
        ]);
    }

    render() {
        
        let moreInfoTooltipClass = "more-info-tooltip";
        if (this.state.moreInfoTooltipVisible) {
            moreInfoTooltipClass += " visible";
        }
        let integrationStatusMessageClass = "integration-status";
        switch (this.props.integrationsFleetioCredentialsStatus) {
            case "ERROR":
                integrationStatusMessageClass += " error-message";
                break;
            /* I'm not certain about this:
            case "ENABLED":
                integrationStatusMessageClass += " success-message";
                break; */
            default:
                integrationStatusMessageClass += " info-message";
                break;
        }
        return (
            <div className="setting-group-horiz">
                <div className={moreInfoTooltipClass}>
                    {strings.settings_global_integrations_fleetio_more_info}
                </div>
                <div className={this.props.integrationsFleetioCredentialsExpandReferenceIsExpanded ? "subgroup" : "subgroup collapsed"}>
                    <div>
                        <h5 className="subgroup-header">
                            <button disabled={true} // SUBSECTION_COLLAPSING_DISABLED
                                className={this.props.integrationsFleetioCredentialsExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                                onClick={() => {
                                    this.props.expandOrCollapseStateForUIReferences(
                                        !this.props.integrationsFleetioCredentialsExpandReferenceIsExpanded,
                                        [this.props.integrationsFleetioCredentialsExpandReference])
                                }}>
                                {strings.settings_global_integrations_fleetio_header}
                                <span
                                    className="more-info"
                                    onMouseEnter={() => {this.setState({moreInfoTooltipVisible: true})}}
                                    onMouseLeave={() => {this.setState({moreInfoTooltipVisible: false})}}
                                >
                                    <i className="material-icons">
                                        info
                                    </i>
                                </span>
                                <i className="material-icons disclosure">keyboard_arrow_up</i>
                            </button>
                        </h5>
                    </div>
                    <div className="description">
                        <a href="https://help.fleetio.com/s/" target="_blank" rel="noopener noreferrer" className="help">
                            <i className="material-icons">
                                help
                            </i>
                            {strings.help_menu_title}
                        </a>
                    </div>
                    <div className="setting-group">
                        <div className="form no-form-indent">
                            {this.props.integrationsFleetioCredentialsAccountToken && this.props.integrationsFleetioCredentialsApiKey ?
                                <>
                                <div className="account-integrations">
                                    <label>{strings.settings_global_integrations_fleetio_credentials_account_token_label}</label>
                                    <input className="small" autoComplete="new-password" disabled type="text" value={this.props.integrationsFleetioCredentialsAccountToken? this.props.integrationsFleetioCredentialsAccountToken.substring(0,6) + "..." : null} placeholder={strings.settings_global_integrations_fleetio_credentials_account_token_placeholder} onChange={this.handleSSIDChange}></input>
                                </div>
                                <div className="account-integrations">
                                    <label>{strings.settings_global_integrations_fleetio_credentials_api_key_label}</label>
                                    <input autoComplete="new-password" disabled type={"text"} value={this.props.integrationsFleetioCredentialsApiKey? this.props.integrationsFleetioCredentialsApiKey.substring(0,15) + "..." : null} placeholder={strings.settings_global_integrations_fleetio_credentials_api_key_placeholder} onChange={this.handlePasswordChange}></input>
                                </div>
                                <div className="verification-icons">
                                    {/* Verification not supported
                                    this.props.integrationsFleetioCredentialsVerificationIsValid ?
                                        <i className="material-icons status-verified">
                                            check_circle_outline
                                        </i>
                                    :
                                        <i className="material-icons status-failed">
                                            error_outline
                                        </i>
                                    */}
                                    {/*this.props.integrationsFleetioCredentialsVerificationPending ? <ProgressOverlay /> : null */}
                                </div>
                                <div className="form-actions">
                                    <button onClick={() => {
                                        this.props.showConfirmationDialog(
                                            <ModalContainer title={strings.settings_global_integrations_fleetio_remove_fleetio_credentials} smallDialogMode={true} onClickClose={this.props.dismissConfirmationDialog}>
                                                <div className="message">
                                                    <p>{strings.settings_global_integrations_fleetio_remove_fleetio_credentials_message}</p>
                                                </div>
                                                <div className="actions">
                                                    <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                                                    <button onClick={() => {
                                                        this.applyIntegrationsFleetioCredentialsTimeoutId = setTimeout(() => {this.props.timeoutIntegrationsFleetioCredentials(undefined, undefined)}, UPDATE_SETTINGS_TIMEOUT);
                                                        this.props.dismissConfirmationDialog();
                                                        this.props.applyIntegrationsFleetioCredentials(undefined, undefined, this.props.integrationsFleetioCredentialsIntegrationId) // applying undefined akin to other preexisting 'delete'/'remove' ops in Global Settings
                                                        .then(
                                                            () => {clearTimeout(this.applyIntegrationsFleetioCredentialsTimeoutId)},
                                                            () => {clearTimeout(this.applyIntegrationsFleetioCredentialsTimeoutId)}
                                                        )
                                                    }} >{strings.action_remove_credentials}</button>
                                                </div>
                                            </ModalContainer>
                                        )
                                    }} className="btn btn-outline-red">{strings.settings_action_remove}</button>
                                </div>
                                </>
                            :
                                // credentials not found
                                <div className="form-actions">
                                    <button className="btn btn-blue" onClick={() => {
                                        this.props.showConfirmationDialog(
                                            <ModalContainer title={strings.settings_global_integrations_fleetio_add_fleetio_credentials} smallDialogMode={true} >
                                                <IntegrationsAddFleetioCredentials
                                                    applyIntegrationsFleetioCredentials = {(accountToken, apiKey) => {
                                                        this.applyIntegrationsFleetioCredentialsTimeoutId = setTimeout(() => {this.props.timeoutIntegrationsFleetioCredentials(accountToken, apiKey)}, UPDATE_SETTINGS_TIMEOUT);
                                                        this.props.dismissConfirmationDialog();
                                                        this.props.applyIntegrationsFleetioCredentials(accountToken, apiKey)
                                                        .then(
                                                            () => {clearTimeout(this.applyIntegrationsFleetioCredentialsTimeoutId)},
                                                            () => {clearTimeout(this.applyIntegrationsFleetioCredentialsTimeoutId)}
                                                        )
                                                    }}
                                                    dismissConfirmationDialog = {this.props.dismissConfirmationDialog}
                                                />
                                            </ModalContainer>
                                        );

                                    }}>{strings.settings_action_add_credentials}</button>
                                </div>
                            }
                        
                        </div>
                        <div className="error-message form-indent">
                            {this.props.integrationsFleetioCredentialsErrorMessage}
                        </div>
                        {this.props.integrationsFleetioCredentialsStatusMessage &&
                            <div className={integrationStatusMessageClass}>
                                <span className="status-label">{strings.settings_global_integrations_status_colon}</span>{this.props.integrationsFleetioCredentialsStatusMessage}
                            </div>
                        }
                        {this.props.integrationsFleetioCredentialsPending ? <ProgressOverlay /> : null }
                    </div>
                </div>
            </div>
        );
    }
}

class IntegrationsAddFleetioCredentials extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            accountToken: "",
            accountTokenValidationErrorMessage: null,
            apiKey: "",
            apiKeyValidationErrorMessage: null
        }
    }

    static propTypes = {
        applyIntegrationsFleetioCredentials: PropTypes.func.isRequired,
        dismissConfirmationDialog: PropTypes.func.isRequired
    }

    onInputChange = (event) => {
        const trimmedValue = event.target.value.trim();
        switch (event.target.id) {
            case "integrations-fleetio-account-token":
                this.setState({
                    accountToken : trimmedValue.substring(0, ACCOUNT_TOKEN_MIN_LENGTH),
                    accountTokenValidationErrorMessage: trimmedValue.length < ACCOUNT_TOKEN_MIN_LENGTH ? strings.formatString(strings.settings_global_integrations_fleetio_account_token_min_length_validation_message, ACCOUNT_TOKEN_MIN_LENGTH) : null
                });
                break;
            case "integrations-fleetio-api-key":
                this.setState({
                    apiKey : trimmedValue,//.substring(0, API_KEY_MIN_LENGTH),
                    apiKeyValidationErrorMessage: trimmedValue.length < API_KEY_MIN_LENGTH ? strings.formatString(strings.settings_global_integrations_fleetio_api_key_min_length_validation_message, API_KEY_MIN_LENGTH) : null
                });
                break;
            default:
                console.warn("IntegrationsAddFleetioCredentials onInputChange unknown input");
                return;
        }
    }

    onSubmit = (event) => {
        // assumption, validation already handled onInputChange and submit button is enabled/disabled accordingly
        this.props.applyIntegrationsFleetioCredentials(this.state.accountToken, this.state.apiKey);
    }

    render() {
        let disableSubmitButton = false;
        if (this.state.accountTokenValidationErrorMessage || this.state.apiKeyValidationErrorMessage) {
            disableSubmitButton = true;
        }
        if (!this.state.accountToken || !this.state.apiKey) {
            disableSubmitButton = true;
        }
        return (
            <div className="settings-default-modal integrations">
                <div className="message">
                    <input autoComplete="new-password" type="text" id="integrations-fleetio-account-token" className="integrations-account-token" value={this.state.accountToken} placeholder={strings.settings_global_integrations_fleetio_credentials_account_token_placeholder} onChange={this.onInputChange} />
                    <div className="error-message">{this.state.accountTokenValidationErrorMessage}</div>
                    <input autoComplete="new-password" type="text" id="integrations-fleetio-api-key" value={this.state.apiKey} placeholder={strings.settings_global_integrations_fleetio_credentials_api_key_placeholder} onChange={this.onInputChange} />
                    <div className="error-message">{this.state.apiKeyValidationErrorMessage}</div>
                </div>
                <div className="error-message">
                    {this.state.credentialsAreIncompleteError}
                </div>
                <div className="actions">
                    <button className="destructive" onClick={this.props.dismissConfirmationDialog} >{strings.action_cancel}</button>
                    <button onClick={this.onSubmit} disabled={disableSubmitButton} >{strings.action_save}</button>
                </div>
            </div>
        );
    }
}
